import { useContext } from "react"
import { FormContext } from "../../context/formContext"
import { useFormikContext } from "formik"
import { InputText as Input } from "primereact/inputtext"
import DescriptionTooltip from "./helpers/DescriptionTooltip";
import styles from "../../styles/Form.module.css"

export default function TypeZipcode({ field, block, index }) {
  const isRequired = JSON.parse(field.field_validation.required[0])
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  return (
    <div className={styles.field} style={{ order: index }}>
      <label className={styles.label} style={{ gap: "10px" }}>
        <span>
          {field.field_label}
          {isRequired && <span className={styles.asterisk}> *</span>}
        </span>
        {field.field_description &&
          <DescriptionTooltip
            fieldName={field.field_name}
            fieldDescription={field.field_description}
          />
        }
      </label>
      <Input
        name={field.field_name}
        disabled={isDisabled}
        value={formik.values[field.field_name]}
        onChange={({ target: { value } }) =>
          formik.setFieldValue(field.field_name, value)
        }
      />
    </div>
  )
}
